import type { ILocationExportCmd } from "@/data/commands/location/LocationExportCmd";
import { Factory } from "@/data/dao/Factory";
import { LocationDao } from "@/data/dao/service/LocationDao";

import { BaseModal } from "@/shared/elements/BaseModal";
import { logError } from "@/shared/logging/errors";
import { style } from "@/shared/ui/Style";

import { i18n } from "@/portal/Trans";
import { Select } from "@/portal/formControls/Select";
import { UiNotification } from "@/portal/ui/Notification";

export class LocationExportWindow extends BaseModal {
    private $form: JQuery;
    private $submitBtn: JQuery;

    private viewTypeSelect: Select<{ value: string; name: string }>;

    constructor() {
        super(i18n("modal.locationExport.title"), "modal-md", false);

        this.$element.addClass("locationexport");

        this.$form = $('<form class="kt-form kt-form--label-right" />').appendTo(this.$body);

        const createSection = $('<div class="kt-section kt-section--first"><div class="kt-section__body" /></div>')
            .appendTo(this.$form)
            .find("> .kt-section__body");
        createSection.append(
            '<div class="row"><label class="col-xl-4"></label><div class="col-lg-9 col-xl-6"><h3 class="kt-section__title kt-section__title-sm">' +
                i18n("modal.locationExport.exportSetting") +
                "</h3></div></div>"
        );

        const viewTypeGroup = $(
            '<div class="form-group row"><label class="col-xl-4 col-form-label">' +
                i18n("modal.locationExport.viewType") +
                ' <span class="mandatory">*</span></label><div class="col-xl-6" /></div>'
        )
            .appendTo(createSection)
            .find("> .col-xl-6");
        const viewTypeSelect = $('<select class="form-control" />').appendTo(viewTypeGroup);
        viewTypeSelect.append('<option value="false">' + i18n("modal.locationExport.withoutRooms") + "</option>");
        viewTypeSelect.append('<option value="true">' + i18n("modal.locationExport.withRooms") + "</option>");
        this.viewTypeSelect = Select.createFromSelect(viewTypeSelect);

        $('<button type="button" class="btn btn-secondary">' + i18n("general.cancel") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();
                this.close();
            });

        this.$submitBtn = $('<button type="button" class="btn btn-success">' + i18n("general.export") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();
                this.$form.submit();
            });

        this.$form.submit((e) => {
            e.preventDefault();
            e.stopPropagation();

            this.onExport();

            return false;
        });
    }

    protected onShow() {}

    protected onHide() {}

    private onExport() {
        const data: ILocationExportCmd = {
            withRooms: this.viewTypeSelect.getValue() === "true",
        };

        const hasError = false;
        this.$form.find(".is-invalid").removeClass("is-invalid");

        if (hasError) return;

        this.$submitBtn.addClass(style.buttonLoaderClass).prop("disabled", true).find("> .la").remove();
        Factory.getInstance<LocationDao>(LocationDao)
            .exportLocations(data)
            .then(() => {
                this.$submitBtn.removeClass(style.buttonLoaderClass).prop("disabled", false);
                this.close();
            })
            .catch((ex) => {
                logError(ex);
                UiNotification.showException(i18n("modal.locationExport.failedExport"));
            });
    }
}
